var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickQustion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "88.000000pt",
    height: "88.000000pt",
    viewBox: "0 0 88.000000 88.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,88.000000) scale(0.100000,-0.100000)",
    fill: "#9c9c9c",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313 810 c-12 -5 -24 -18 -28 -29 -3 -12 -15 -21 -26 -21 -10 0 -19 -7 -19 -15 0 -12 -15 -15 -75 -15 l-75 0 2 -332 3 -333 260 0 260 0 3 333 2 332 -80 0 c-64 0 -80 3 -80 15 0 8 -5 15 -11 15 -6 0 -24 14 -39 30 -29 31 -56 36 -97 20z m85 -47 c2 -15 10 -23 23 -23 12 0 19 -7 19 -20 0 -18 -7 -20 -85 -20 -47 0 -85 2 -85 4 0 2 -3 11 -6 20 -4 11 0 16 14 16 13 0 22 9 26 26 6 23 11 25 49 22 35 -2 43 -7 45 -25z m-158 -68 c0 -12 19 -15 110 -15 91 0 110 3 110 15 0 12 14 15 65 15 l65 0 0 -310 0 -310 -240 0 -240 0 0 310 0 310 65 0 c51 0 65 -3 65 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 630 c0 -6 37 -10 90 -10 53 0 90 4 90 10 0 6 -37 10 -90 10 -53 0 -90 -4 -90 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 565 c0 -13 23 -15 180 -13 243 4 245 22 3 26 -160 2 -183 0 -183 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 495 c0 -13 23 -15 180 -13 243 4 245 22 3 26 -160 2 -183 0 -183 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 420 c0 -6 68 -10 185 -10 117 0 185 4 185 10 0 6 -68 10 -185 10 -117 0 -185 -4 -185 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 350 c0 -6 68 -10 185 -10 117 0 185 4 185 10 0 6 -68 10 -185 10 -117 0 -185 -4 -185 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 280 c0 -6 68 -10 185 -10 117 0 185 4 185 10 0 6 -68 10 -185 10 -117 0 -185 -4 -185 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 210 c0 -6 68 -10 185 -10 117 0 185 4 185 10 0 6 -68 10 -185 10 -117 0 -185 -4 -185 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 140 c0 -6 69 -10 186 -10 121 0 183 3 179 10 -8 14 -365 14 -365 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 800 c-19 -19 -20 -33 -20 -317 l0 -298 29 -55 c16 -30 34 -56 39 -58 6 -2 22 19 36 47 l26 50 0 315 c0 301 -1 316 -19 326 -31 16 -69 12 -91 -10z m90 -25 c0 -11 -11 -15 -40 -15 -29 0 -40 4 -40 15 0 11 11 15 40 15 29 0 40 -4 40 -15z m0 -55 c0 -17 -7 -20 -40 -20 -33 0 -40 3 -40 20 0 17 7 20 40 20 33 0 40 -3 40 -20z m-52 -288 c2 -211 0 -242 -13 -242 -13 0 -15 33 -15 246 0 192 3 245 13 242 9 -4 13 -64 15 -246z m52 3 c0 -211 -2 -245 -15 -245 -13 0 -15 33 -15 238 0 131 3 242 7 245 20 20 23 -14 23 -238z m-10 -270 c0 -11 -24 -55 -30 -55 -6 0 -30 44 -30 55 0 3 14 5 30 5 17 0 30 -2 30 -5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickQustion);
export default __webpack_public_path__ + "static/media/quick-qustion.f82975e37781846c1a5561aa0b97a264.svg";
export { ForwardRef as ReactComponent };